
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/[customerId]/manage/channels",
      function () {
        return require("private-next-pages/d/[customerId]/manage/channels.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/[customerId]/manage/channels"])
      });
    }
  